import { render } from "./BaseLoadingSpinner.vue?vue&type=template&id=2ff20cc4&scoped=true"
import script from "./BaseLoadingSpinner.vue?vue&type=script&lang=js"
export * from "./BaseLoadingSpinner.vue?vue&type=script&lang=js"

import "./BaseLoadingSpinner.vue?vue&type=style&index=0&id=2ff20cc4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ff20cc4"],['__file',"src/components/BaseLoadingSpinner.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2ff20cc4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2ff20cc4', __exports__)) {
    api.reload('2ff20cc4', __exports__)
  }
  
  module.hot.accept("./BaseLoadingSpinner.vue?vue&type=template&id=2ff20cc4&scoped=true", () => {
    api.rerender('2ff20cc4', render)
  })

}


export default __exports__